import { render, staticRenderFns } from "./NewDoctor.vue?vue&type=template&id=fee38ee2&scoped=true"
import script from "./NewDoctor.vue?vue&type=script&lang=js"
export * from "./NewDoctor.vue?vue&type=script&lang=js"
import style0 from "./NewDoctor.vue?vue&type=style&index=0&id=fee38ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee38ee2",
  null
  
)

export default component.exports